import styled from 'styled-components';
import { Search } from '@styled-icons/boxicons-regular/Search';

export const Container = styled.div`
  margin: 1rem 0 2.5rem 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 0.5rem;
  padding: 0 1.5rem;

  & > div.search-items-content > header {
    & > h4 {
      color: ${({ theme }) => theme.colors.grayDark};
      font-weight: 600;
      font-size: 0.875rem;
    }

    & > span {
      font-family: ${({ theme }) => theme.fonts.workSans};
      color: ${({ theme }) => theme.colors.grayDark4};
      font-size: 0.875rem;
    }
  }
`;

export const SearchItemInputContainer = styled.div`
  margin-top: 1rem;
  position: relative;
  display: flex;
  align-items: center;

  & > div {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    min-height: 2rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      padding: 0;
    }

    &.loading {
      background-color: ${({ theme }) => theme.colors.gray1};
    }

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.lightBlue};
    }

    & > input {
      border: none;
      outline: none;
      padding-bottom: 0.05rem;
      flex-grow: 1;

      &:placeholder-shown {
        font-style: italic;
        padding-left: 0.25rem;
        font-size: 0.75rem;
        @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
          font-size: 0.875rem;
        }
      }

      &:disabled {
        background-color: ${({ theme }) => theme.colors.gray1};
      }
    }

    & > .search-tag {
      background: ${({ theme }) => theme.colors.white2};
      border: 1px solid ${({ theme }) => theme.colors.white3};
      font-size: 0.875rem;

      max-width: 90%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
        max-width: 100%;
      }
    }
  }

  & > div.search-items-button {
    display: flex;
    width: 25%;
    border: none !important;
    padding: 1.2rem 0 0 0 !important;
    margin-left: 1.5rem;

    & > button {
      border: none !important;
      width: 100%;
    }
  }
`;

export const SearchIcon = styled(Search)`
  width: 1.2rem;
`;

export const ContainerChipsAdded = styled.div`
  font-size: 0.875rem;
  margin: 1rem 0rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark3};
`;
